import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-upd-direccion',
  templateUrl: './upd-direccion.component.html',
  styleUrls: ['./upd-direccion.component.scss']
})
export class UpdDireccionComponent {
  @Input() buttonOnlyIcon: boolean = false;
  @Input() id_cliente: number = null
  @Input() dataDireccion: any
  updDireccionForm: FormGroup;
  @Output() updateData = new EventEmitter();
  regiones: Array<any> = []
  provincias: Array<any> = []
  comunas: Array<any> = []
  comuna: any
  mapa: any = ""

  constructor(private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    private loadingService: LoadingService,
    protected sanitizer: DomSanitizer) { }

  async ngOnInit() {
    await this.getComunas();
    await this.getComuna(this.dataDireccion.comuna_id);
    this.initializeForm();
    this.chargeMap(this.updDireccionForm.value)
  }

  async initializeForm() {
    this.updDireccionForm = this.fb.group({
      id_cliente: [this.id_cliente, Validators.required],
      id_direccion: [this.dataDireccion.id_direccion],
      direccion: [this.dataDireccion.direccion, Validators.required],
      comuna_id: [this.dataDireccion.comuna_id, Validators.required],
      comuna_nombre: [this.dataDireccion.comuna_nombre],
      provincia_nombre: [this.comuna.provincia_nombre],
      region_nombre: [this.comuna.region_nombre],
      detalle: [this.dataDireccion.detalle]
    });
  }


  open(content: any) {
    if (!this.id_cliente) return
    if (!this.dataDireccion) return
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then(async (result) => {
      this.loadingService.setLoading(true)
      if (result.direccion && result.comuna_id == -1) {
        this.loadingService.setLoading(false)
        this.toastr.error('Debe indicar una comuna!')
        return
      }
      let geocode = await this.generalService.getListar(`geo-utils/geocode?address=${result.direccion},${result.comuna_nombre},${result.provincia_nombre},${result.region_nombre}`)

      this.generalService
        .putEdita("direccion", result.id_direccion, {
          id_cliente: result.id_cliente,
          direccion: result.direccion,
          comuna_id: result.comuna_id,
          detalle: result.detalle,
          latitud: geocode.data.lat ? geocode.data.lat : null,
          longitud: geocode.data.lng ? geocode.data.lng : null
        })
        .then(res => {
          this.toastr.success('Dirección actualizada exitosamente!');
          this.loadingService.setLoading(false)
          this.updateData.emit();
          this.initializeForm(); 
        })
        .catch(err => {
          this.toastr.error('Error al actualizar dirección!')
          this.loadingService.setLoading(false)
        });

    }, (reason) => {
      this.loadingService.setLoading(false)
      //Cerrasdo por X, ESC, backdrop
    });
  }

  async getComunas() {
    try {
      let res = await this.generalService.getListar("comunas")
      this.comunas = res.data;
    } catch (error) {
      this.comunas = [];
    }
  }

  async getComuna(idComuna) {
    try {
      let res = await this.generalService.getObtiene("comunas", idComuna)
      this.comuna = res.data;
    } catch (error) {
      this.comunas = [];
    }
  }

  onSelectItemComuna(item) {
    if(item == null)
    {
      this.updDireccionForm.get('comuna_id').setValue(null);
      this.updDireccionForm.get('provincia_nombre').setValue(null);
      this.updDireccionForm.get('region_nombre').setValue(null);
      return
    }
    this.updDireccionForm.get('comuna_id').setValue(item.comuna_id);
    this.updDireccionForm.get('provincia_nombre').setValue(item.provincia_nombre);
    this.updDireccionForm.get('region_nombre').setValue(item.region_nombre);
    this.chargeMap(this.updDireccionForm.value)
  }

  chargeMap(item){
    if (!item.direccion || !item.comuna_nombre) return
    this.mapa = this.sanitizer.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${item.direccion},+${item.comuna_nombre},+${item.provincia_nombre},+${item.region_nombre}&t=&z=15&ie=UTF8&iwloc=&output=embed`);
  }
}
